import api from "@/requests";

export const fetchRedStatement = async ({ beginDate, endDate }) =>
  api.post(
    `api/v1/Myred/GetKaspiRedStatement`,
    {
      beginDate,
      endDate,
    },
    {
      showLoader: false,
    }
  );

export const fetchRedModel = (showLoader) =>
  api.get(`api/v1/Myred/GetRedActions`, {
    showLoader,
    showAlert: false,
  });

export const fetchArrestData = async (simpleId, page = 1) =>
  api.get(
    `${window.mybank_settings.api.publicAPI}/api/v1/Arrests/GetClientArrests/${simpleId}/${page}`
  );

export const getOnlineStub = () => api.get("/api/v1/Myred/GetOnlineRedStub");

export const lockCard = (simpleId) =>
  api.post(`/api/v1/TmCard/CardLock/${simpleId}`);
